import { Table } from '../../../../components/general/table';
import { useStrategicAllyList } from './hook';
import { StrategicAllyListProps } from './props';

export const StrategicAllyList = ({
    filters,
    onClickRow,
}: StrategicAllyListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useStrategicAllyList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(row) => onClickRow && onClickRow(row.row)}
        />
    );
};
